// @flow

import React from "react";
import { localize } from "redux-i18n";

import { GSGrid } from "@components";
import type {
  ComplianceReportData,
  ComplianceReportViewState,
} from "@modules/reporting/reducer/trends/compliance/types";

type OwnProps = $Exact<{
  reportData: ComplianceReportData,
  reportDetails: { name: string },
  viewState: ComplianceReportViewState,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export function TrendComplianceReportTable(props: Props) {
  const { reportDetails, reportData, viewState, t } = props;

  const periods = (reportData.details[0] && reportData.details[0].periods) || [];

  const firstColumnTitle = reportDetails.name.search(/manager/gi) > 0 ? "MANAGER" : "DEPARTMENT";
  return (
    <div className="w-100">
      <GSGrid
        id="trend-compliance-table"
        rows={reportData.details.map((row: Object) => {
          return {
            ...row,
            key: row.id,
            isExpanded: row.hierarchy.length <= 1,
          };
        })}
        rowHeight={viewState.showFractions ? 60 : 40}
        groupColumn={{
          key: firstColumnTitle.toLowerCase(),
          name: t(firstColumnTitle),
          frozen: "left",
        }}
        columns={[
          ...periods.map(cRow => {
            return {
              key: cRow.period,
              name: cRow.period,

              width: 80,
              renderCell: ({ row }: *) => {
                const period = row.periods.find(p => p.period == cRow.period);
                let data = {};
                if (period) {
                  data = {
                    percent: period.compliancePercentage,
                    total: period.completedOnTime,
                    max: period.total,
                    showFractions: viewState.showFractions,
                    threshold: 80,
                    withoutWarningColor: true,
                  };
                }
                return GSGrid.render.percentFractionIndicator(data);
              },
            };
          }),
          {
            name: "Trend",
            key: "trend",
            width: 100,
            frozen: "right",
            cellClass: "p-1px",
            renderCell: ({ row }: *) => {
              return GSGrid.render.sparklineIndicator({
                rowHeight: 40,
                periods: (row.periods || []).map(p => ({ ...p, value: p.total })),
              });
            },
          },
          {
            name: t("TOTAL_OVER_12_MONTHS"),
            key: "TOTAL_OVER_12_MONTHS",
            width: viewState.showFractions ? 150 : 140,
            frozen: "right",
            cellClass: "p-1px",
            renderCell: ({ row }: *) => {
              return GSGrid.render.percentFractionBarIndicator({
                total: row.completedOnTime,
                max: row.total,
                percent: row.compliancePercentage,
                count: row.completedOnTime,
                showFractions: viewState.showFractions,
                withoutWarningColor: true,
              });
            },
          },
        ]}
      />
    </div>
  );
}

export default localize()(TrendComplianceReportTable);
